//src/pages/questions/CreateAssessmentPage1.js
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../../styles/global.css";
import { backicon } from "../../assets/icons/icons";
import { IoMdArrowRoundBack } from "react-icons/io";
import { BsFillInfoCircleFill } from "react-icons/bs";

const CreateAssessmentPage1 = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const [difficulty, setDifficulty] = useState("");
  const [testType, setTestType] = useState("PrePost");
  const [sections, setSections] = useState({
    conversational_ai: false,
    subjective: false,
    objective: false,
  });
  const [isNextDisabled, setIsNextDisabled] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  // Check if all required fields are filled
  useEffect(() => {
    if (!difficulty) {
      setErrorMessage("Select difficulty type ");
    } else if (!testType) {
      setErrorMessage("Select the test type");
    } else if (
      !sections.conversational_ai &&
      !sections.subjective &&
      !sections.objective
    ) {
      setErrorMessage("Select at least one section");
    } else {
      setErrorMessage("");
    }
    const isFormComplete =
      difficulty &&
      testType &&
      (sections.conversational_ai || sections.subjective || sections.objective);

    setIsNextDisabled(!isFormComplete);
  }, [difficulty, testType, sections]);

  const handleNext = () => {
    if (isNextDisabled) {
      setErrorMessage("Please fill out all required fields");
    } else {
      navigate(`/create-assessment/step2/${projectId}`, {
        state: { difficulty, testType, sections },
      });
    }
  };

  const backButtonHandler = () => {
    navigate("/projects");
  };

  return (
    <div className="lg:w-7/12 w-11/12 mx-auto pt-6">
      <div className="flex items-center lg:gap-20 md:gap-10 gap-3">
       
              <div className="w-full max-w-5xl mb-6">
                <button
                  onClick={backButtonHandler}
                  className="group flex items-center gap-3 px-5 py-2.5 rounded-full bg-gradient-to-r from-red-500 to-pink-500 text-white font-semibold shadow-md hover:scale-105 active:scale-95 transition"
                >
                  <IoMdArrowRoundBack className="text-xl group-hover:-translate-x-1 transition" />
                  <span className="hidden md:block">Back</span>
                </button>
              </div>
        {/* <img className="w-20 p-5" onClick={backButtonHandler}  src={backicon} alt="Back"/> */}
   
      </div>
    <h2 className="text-2xl md:text-3xl font-bold bg-[#36369f] text-transparent bg-clip-text text-center w-full">
  Create your own questions <br /> according to the difficulty
</h2>
      <div className="mx-auto flex flex-col justify-items-center lg:py-20 py-10">
        {errorMessage && (
          <div
            className=" mx-auto rounded-lg  
            "
          >
            <p className="text-red-500 lg:text-lg md:text-base text-center">{errorMessage}</p>
          </div>
        )}
        <div className="items-center flex flex-col justify-center w-full">

  
  <div className="w-full flex md:flex-row flex-col gap-6">

    
    <div className="md:w-1/2 w-full">
      <label className="block mb-2 text-sm font-semibold text-gray-700">
        Difficulty Level
      </label>

      <select
        value={difficulty}
        onChange={(e) => setDifficulty(e.target.value)}
        className="w-full rounded-xl py-3 px-4 text-sm md:text-base border border-gray-200 
                   focus:outline-none focus:ring-2 focus:ring-purple-400 
                   shadow-sm bg-white"
      >
        <option value="">Select Difficulty</option>
        <option value="Easy">Easy</option>
        <option value="Moderate">Moderate</option>
        <option value="Difficult">Difficult</option>
      </select>
    </div>

    
    <div className="w-full">
      <label className="block mb-2 text-sm font-semibold text-gray-700">
        Choose Test Type
      </label>

      <div className="relative flex bg-gray-100 rounded-xl p-1 shadow-inner">

        <div
          className={`absolute top-1 left-1 w-[calc(50%-4px)] h-[calc(100%-8px)] bg-white rounded-xl shadow-md transition-all duration-300 ${
            testType === "PostTest" ? "translate-x-full" : ""
          }`}
        ></div>

        <button
          className={`flex-1 z-10 py-3 text-xs md:text-sm flex items-center justify-center gap-2 transition ${
            testType === "PrePost"
              ? "text-purple-700 font-semibold"
              : "text-gray-500"
          }`}
          onClick={() => setTestType("PrePost")}
        >
          Two Assessments Pre and Post
          <BsFillInfoCircleFill className="text-gray-400" />
        </button>

       
        <button
          className={`flex-1 z-10 py-3 text-xs md:text-sm flex items-center justify-center gap-2 transition ${
            testType === "PostTest"
              ? "text-purple-700 font-semibold"
              : "text-gray-500"
          }`}
          onClick={() => setTestType("PostTest")}
        >
          One Assessment
          <BsFillInfoCircleFill className="text-gray-400" />
        </button>
      </div>
    </div>
  </div>

  
  <div className="w-full mt-8">
    <label className="block mb-3 text-sm font-semibold text-gray-700">
      Select Sections
    </label>

    <div className="grid md:grid-cols-3 gap-4">

      
      {[
        {
          key: "conversational_ai",
          label: "Conversational AI",
        },
        {
          key: "subjective",
          label: "Subjective Questions",
        },
        {
          key: "objective",
          label: "Objective Questions",
        },
      ].map((item) => (
        <label
          key={item.key}
          className={`cursor-pointer rounded-xl border p-4 flex items-center gap-3 transition-all
            ${
              sections[item.key]
                ? "border-purple-400 bg-purple-50 shadow-md"
                : "border-gray-200 bg-white hover:shadow"
            }`}
        >
          <input
            type="checkbox"
            checked={sections[item.key]}
            onChange={() =>
              setSections({
                ...sections,
                [item.key]: !sections[item.key],
              })
            }
            className="accent-purple-600 w-4 h-4"
          />
          <span className="text-sm font-medium text-gray-700">
            {item.label}
          </span>
        </label>
      ))}
    </div>
  </div>


  <div className="mt-10 w-full flex justify-center">
    <button
      className={`px-8 py-3 rounded-xl text-sm md:text-base font-semibold transition-all duration-300
        ${
          isNextDisabled
            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
            : "bg-gradient-to-r from-purple-600 to-pink-500 text-white hover:scale-105 shadow-lg"
        }`}
      onClick={handleNext}
      disabled={isNextDisabled}
    >
      Proceed to Create Assessment →
    </button>
  </div>
</div>
      </div>
    </div>
  );
};

export default CreateAssessmentPage1;